
export default {
  list: [],
  isUnique: true
}



// WEBPACK FOOTER //
// ./src/features/admin/servicos/store/state.js